import { useEffect } from "react";

import LayoutDashboard from "../components/layout/LayoutDashboard.component";

import { usePacotes } from "../services";

import { toJS } from "mobx";
import { useStores } from "../components/contexts/store-provider.context";
import { TablePacotes } from "../components/pacotes";
import { memoObserver } from "../utils/memoObserver.utils";

export const Pacotes = memoObserver(() => {
  const { getPacotes } = usePacotes();
  const { produtoStore } = useStores();

  useEffect(() => {
    getPacotes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <LayoutDashboard>
      <TablePacotes
        loading={produtoStore.loading}
        data={toJS(produtoStore.data) || []}
      />
    </LayoutDashboard>
  );
});

export default Pacotes;
